<template>
  <div class="gps-ranking-section">
    <div class="gps-ranking-section__list">
      <gps-ranking-player-parts
        v-for="playerLiveTiming in rankingData"
        :key="playerLiveTiming.id"
        :selectedID="checkSelectedID()"
        :rank="playerLiveTiming.position"
        :player="playerLiveTiming"
        :img="playerPictureUrl(playerLiveTiming)"
      />
    </div>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, PropType } from '@vue/composition-api'
import GpsRankingPlayerParts from '@/components/RaceVideoPage/RaceVideoGpsPane/parts/GpsRankingPlayerParts.vue'
import { PlayerLiveTimingDataType } from '@/store/stores/collectionModule/documents/liveTiming/PlayerLiveTiming'
import CloudFrontUtil from '@/util/aws/CloudFrontUtil'

/**
 * レース動画再生画面: GPS詳細 ランキングセクション
 */
export default defineComponent({
  name: 'GpsRankingSection',
  components: {
    GpsRankingPlayerParts,
  },
  props: {
    /**
     * 選択中選手ID
     */
    selectedID: {
      type: String,
      default: '',
    },
    /**
     * 選手のライブタイミングデータ
     */
    rankingData: {
      type: Array as PropType<Array<PlayerLiveTimingDataType>>,
      required: true,
      default: () => [],
    },
  },
  setup(props) {
    const currentPlayerId = computed(() => props.selectedID)
    const rankingDataList = computed(() => props.rankingData)
    /**
     * 選手顔写真のURLを取得する
     * @param playerLiveTimingData 選手のライブタイミングデータ
     */
    const playerPictureUrl = (playerLiveTimingData: PlayerLiveTimingDataType) =>
      CloudFrontUtil.getSignedUrl(playerLiveTimingData.img)

    /**
     * お気に入り選手のIDを返す。
     * お気に入り選手がレース参加しているかチェックし、存在しない場合は、1位選手のIDを返す。
     */
    const checkSelectedID = () => {
      if (!rankingDataList.value || rankingDataList.value.length === 0) {
        return currentPlayerId.value
      }

      const targetPlayerLiveTiming = rankingDataList.value.find(
        (playerLiveTiming) => playerLiveTiming.id === currentPlayerId.value,
      )
      if (!targetPlayerLiveTiming) {
        // お気に入り選手がライブタイミングデータに含まれないので、先頭のライブタイミングを選択する
        return rankingDataList.value[0].id
      }

      return currentPlayerId.value
    }

    return {
      playerPictureUrl,
      checkSelectedID,
    }
  },
  methods: {},
})
</script>

<style lang="scss" scoped>
.gps-ranking-section {
  width: 100%;
  height: 128px;
  margin: 0 auto;
  padding: 0 0 0 16px;
  overflow-y: hidden;
  overflow-x: scroll;

  &__list {
    display: flex;
    flex-flow: row nowrap;
    align-items: flex-start;
    justify-content: flex-start;
    gap: 8px;

    &::after {
      display: block;
      content: '';
      min-width: 10px;
      height: 1px;
    }
  }
}

@media screen and (max-height: 680px), screen and (max-width: 320px) {
  .gps-ranking-section {
    height: 72px;
  }
}
</style>
